import {
  queryBrandList,
  getCategoryTree,
  queryAttrList,
  queryProductList,
  getAttr,
  querySkuList
} from "@root/graphql/Root.gql";
import { easyMutate, resRest } from "@root/lib/utils";

export default {
  namespaced: true,
  state: {
    brandList: [],
    catgoryList: [],
    skuAttrList: [],
    spuAttrList: [],
    attrValuesMap: {}
  },
  getters: {},
  actions: {
    async queryBrandList(
      { rootState, commit, state },
      { orgCode = "default", brandName = "", pageNum = 1 }
    ) {
      let condition: any = {
        orgCode
      };
      if (brandName) {
        condition.conditionList = [
          [{ key: "brandName", type: 4, value: brandName }]
        ];
      }
      const { data } = await rootState.gql.query({
        query: queryBrandList,
        variables: {
          condition,
          pageInput: {
            pageSize: 1000,
            pageNum
          }
        }
      });
      let list = data ? resRest(data) : [];
      let total =
        data && data.api && data.api.pageInfo
          ? data.api.pageInfo.totalCount
          : 0;
      commit("easyMutate", {
        path: "brandList",
        data: list
      });
      return { list, total };
    },

    async getCategoryTree(
      { rootState },
      { categoryCode = "-1", orgCode = "default" }
    ) {
      const {
        data: { api: list = [] }
      } = await rootState.gql.query({
        query: getCategoryTree,
        variables: {
          categoryCode,
          orgCode
        }
      });

      return list;
    },

    async queryAttrList(
      { rootState, commit },
      { orgCode = "default", attrType = "sku" }
    ) {
      const { data } = await rootState.gql.query({
        query: queryAttrList,
        variables: {
          condition: {
            orgCode,
            conditionList: [
              [
                // attrValueType 属性值的类型： 0 代表多选型 （其他未知）
                {
                  key: "attrValueType",
                  value: "0",
                  type: 0
                },
                // attrType 代表属性的类型： 1 代表 spu 属性，即商品属性； 2 代表 sku 属性
                {
                  key: "attrType",
                  value: attrType === "spu" ? "1" : "2",
                  type: 0
                }
              ]
            ]
          },
          PageInput: {
            pageNum: 1,
            pageSize: 1000
          }
        }
      });

      commit("easyMutate", {
        path: attrType === "spu" ? "spuAttrList" : "skuAttrList",
        data: data ? resRest(data) : []
      });
    },

    async getAttrInfo(
      { commit, rootState },
      { codeList, orgCode = "default" }
    ) {
      const {
        data: { api: list = [] }
      } = await rootState.gql.query({
        query: getAttr,
        variables: {
          codeList,
          orgCode
        }
      });

      list.forEach(({ values: data, id }) => {
        commit("easyMutate", {
          path: `attrValuesMap.${id}`,
          data
        });
      });
    },

    async queryProductList(
      { rootState },
      { pageInput, searchString, searchConditionList = [], orgCode = "" }
    ) {
      // 搜索条件相关参数
      let conditionList = (searchConditionList.length > 0 &&
        searchConditionList) || [
        {
          key: "productName,productCode",
          value: searchString,
          type: 4
        }
        // { key: "productCode", value: searchString, type: 4 }
      ];
      conditionList = conditionList.filter(({ value }) => !!value);
      // let conditionList =
      //   searchConditionList.length > 0 && searchConditionList
      //     ? searchConditionList
      //     : [
      //         {
      //           key: "productName,productCode",
      //           value: searchString,
      //           type: 4
      //         }
      //         // { key: "productCode", value: searchString, type: 4 }
      //       ];

      // console.log(searchConditionList, "searchConditionLi11 st");
      // conditionList = conditionList.filter(({ value }) => !!value);

      const {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryProductList,
        variables: {
          condition: {
            orgCode,
            sortList: [{ key: "createTime", type: 1 }],
            conditionList
          },
          pageInput: pageInput
        }
      });

      return {
        dataList: resRest(data),
        total
      };
    },

    async querySkuList(
      { rootState },
      { pageInput, searchString, searchConditionList = [], orgCode }
    ) {
      // 搜索条件相关参数
      let conditionList = (searchConditionList.length > 0 &&
        searchConditionList) || [
        {
          key: "skuCode,productCode",
          value: searchString,
          type: 4
        }
        // { key: "productCode", value: searchString, type: 4 }
      ];
      conditionList = conditionList.filter(({ value }) => !!value);

      const {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: querySkuList,
        variables: {
          condition: {
            orgCode,
            sortList: [{ key: "createTime", type: 1 }],
            conditionList
          },
          pageInput: pageInput
        }
      });

      return {
        dataList: resRest(data),
        total
      };
    }
  },
  mutations: {
    easyMutate
  }
};
